export enum Actions {
  GET_CATEGORIES_PENDING = 'GET_CATEGORIES_PENDING',
  GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS',
  GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR',
}
